var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlob(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 358 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.947 11.743c-67.111-25.779-168.671-7.365-177.611 38.135-8.94 45.5-80.532 22.144-102.752 83.159-27.774 76.268 77.362 125.094 134.937 143.389 57.574 18.295 98.818 7.484 109.784-34.095 10.967-41.579-30.277-45.975-7.033-83.159 23.245-37.184 99.295-4.87 111.692-40.985 12.397-36.115-1.907-80.664-69.017-106.444z",
    fill: "url(#blob_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blob_svg__a",
    x1: 340.705,
    y1: 5.44,
    x2: 292.921,
    y2: 309.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4888E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1658BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzU4IDI4NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjg0Ljk0NyAxMS43NDM1Yy02Ny4xMTEtMjUuNzc5Mi0xNjguNjcxLTcuMzY1NDktMTc3LjYxMSAzOC4xMzQzLTguOTM5OSA0NS40OTk3LTgwLjUzMjQgMjIuMTQ0LTEwMi43NTE1OSA4My4xNTkyQy0yMy4xODk2IDIwOS4zMDUgODEuOTQ2MiAyNTguMTMxIDEzOS41MjEgMjc2LjQyNmM1Ny41NzQgMTguMjk1IDk4LjgxOCA3LjQ4NCAxMDkuNzg0LTM0LjA5NSAxMC45NjctNDEuNTc5LTMwLjI3Ny00NS45NzUtNy4wMzMtODMuMTU5IDIzLjI0NS0zNy4xODQgOTkuMjk1LTQuODcgMTExLjY5Mi00MC45ODUgMTIuMzk3LTM2LjExNDktMS45MDctODAuNjY0My02OS4wMTctMTA2LjQ0MzVaIiBmaWxsPSJ1cmwoI2EpIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIzNDAuNzA1IiB5MT0iNS40NDAyNyIgeDI9IjI5Mi45MjEiIHkyPSIzMDkuOTk3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM0ODg4RTgiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTY1OEJBIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };